module.exports = __webpack_public_path__ + "static/media/none.d79467dc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/icons/none.svg
// module id = 677
// module chunks = 0